<template>
  <div>
    <div class="row">
      <div class="col-8">
        <h1>Criação de Rede</h1>
      </div>
      <div class="col-4" style="text-align: right">
        <md-button
          class="md-icon-button md-list-action"
          @click="() => $emit('close')"
        >
          <md-icon>close</md-icon>
          <md-tooltip md-direction="left"> Voltar</md-tooltip>
        </md-button>
      </div>
      <div class="col-12">
        <md-button
          class="md-primary md-raised"
          :disabled="loading"
          @click="criarNo"
        >
          Salvar
        </md-button>

        <md-progress-spinner
          v-if="loading"
          class="mt-2"
          :md-diameter="30"
          :md-stroke="4"
          md-mode="indeterminate"
        />
      </div>
    </div>

    <div>
      <span class="md-caption">
        Selecione um ponto no mapa para criar um nó, em seguida seleciona outro
        nó para formar a rede</span
      >
    </div>

    <br />

    <md-table>
      <md-table-row>
        <md-table-head>Propriedade</md-table-head>
        <md-table-head md-numeric>Valor</md-table-head>
      </md-table-row>

      <md-table-row>
        <md-table-cell>Uid</md-table-cell>
        <md-table-cell md-numeric>
          <div>
            <md-field>
              <label>Uid</label>
              <md-input v-model="form.uid" style="text-align: right"></md-input>
            </md-field>
          </div>
        </md-table-cell>
      </md-table-row>

      <md-table-row>
        <md-table-cell>Inicio</md-table-cell>
        <md-table-cell>
          <div class="row" style="align-items: center">
            <a
              v-if="from"
              class="md-title"
              href="#"
              @click="(e) => $emit('flyto', from)"
            >
              {{ from.idJuncao }}
            </a>
            <md-button
              v-if="from"
              class="md-icon-button md-list-action"
              @click="() => $emit('remove', 'from')"
            >
              <md-icon>close</md-icon>
              <md-tooltip md-direction="right">Remover</md-tooltip>
            </md-button>
          </div>
        </md-table-cell>
      </md-table-row>

      <md-table-row>
        <md-table-cell>Fim</md-table-cell>
        <md-table-cell>
          <div class="row" style="align-items: center">
            <a
              v-if="to"
              class="md-title"
              href="#"
              @click="(e) => $emit('flyto', to)"
            >
              {{ to.idJuncao }}
            </a>
            <md-button
              v-if="to"
              class="md-icon-button md-list-action"
              @click="() => $emit('remove', 'to')"
            >
              <md-icon>close</md-icon>
              <md-tooltip md-direction="right">Remover</md-tooltip>
            </md-button>
          </div>
        </md-table-cell>
      </md-table-row>

      <md-table-row>
        <md-table-cell>Diametro</md-table-cell>
        <md-table-cell md-numeric>
          <div>
            <md-field>
              <label for="data">Diametro</label>
              <md-select id="tipo" v-model="form.diameter" name="tipo">
                <md-option :value="60"> 60mm</md-option>
                <md-option :value="100"> 100mm</md-option>
                <md-option :value="150"> 150mm</md-option>
                <md-option :value="200"> 200mm</md-option>
                <md-option :value="250"> 250mm</md-option>
                <md-option :value="300"> 300mm</md-option>
                <md-option :value="350"> 350mm</md-option>
                <md-option :value="400"> 400mm</md-option>
                <md-option :value="450"> 450mm</md-option>
                <md-option :value="500"> 500mm</md-option>
                <md-option :value="600"> 600mm</md-option>
              </md-select>
            </md-field>
          </div>
        </md-table-cell>
      </md-table-row>

      <md-table-row>
        <md-table-cell>Comprimento</md-table-cell>
        <md-table-cell md-numeric>
          <div>
            <md-field>
              <label>Comprimento</label>
              <md-input
                v-model.number="form.length"
                style="text-align: right"
                number
              ></md-input>
            </md-field>
          </div>
        </md-table-cell>
      </md-table-row>

      <md-table-row>
        <md-table-cell>Rugosidade</md-table-cell>
        <md-table-cell md-numeric>
          <div>
            <md-field>
              <label>Rugosidade</label>
              <md-input
                v-model.number="form.roughness"
                style="text-align: right"
                number
              ></md-input>
            </md-field>
          </div>
        </md-table-cell>
      </md-table-row>
    </md-table>
  </div>
</template>

<script>
import turf from '@turf/turf'

import { EventBus, Topics, Types } from '@/event-bus'
import http from '@/utils/http'

export default {
  name: 'EpanetCreateLink',
  props: {
    simulacaoId: {
      type: String,
      required: true,
    },
    nodes: {
      type: Object,
      required: true,
    },
    links: {
      type: Object,
      required: true,
    },
    from: {
      type: Object,
      default: () => null,
    },
    to: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {
      loading: false,
      changed: {},
      form: {
        uid: '',
        diameter: 60,
        roughness: 130,
        length: 0,
      },
    }
  },
  watch: {
    nodes: {
      handler(newV, oldV) {
        if (newV !== oldV) {
          this.form.uid = `P` + (Object.keys(this.nodes).length + 1) * 2
        }
      },
      deep: true,
    },
    to: {
      handler(newV) {
        if (newV !== null && this.from !== null) {
          // should calculate lenght by difference between from and to plus diff from elevation
          const point1 = turf.point([newV.y, newV.x]) // [longitude, latitude]
          const point2 = turf.point([this.from.y, this.from.x])

          const distance = turf.distance(point1, point2, {
            units: 'meters',
          })

          const elevation1 = newV.properties.elevation
          const elevation2 = this.from.properties.elevation

          const diffElevation = Math.abs(elevation1 - elevation2)

          this.form.length = +Math.sqrt(
            Math.pow(distance, 2) + Math.pow(diffElevation, 2)
          ).toFixed(6)
        }
      },
      deep: true,
    },
  },
  beforeMount() {
    this.form.uid = this.findNextId()
  },
  methods: {
    findNextId() {
      const re = /^FR\d*/

      let maxId = 0

      Object.keys(this.links).forEach((e) => {
        if (re.test(e)) {
          const id = parseInt(e.replace('FR', ''), 10)
          if (id > maxId) {
            maxId = id
          }
        }
      })

      return `FR${maxId + 1}`
    },
    async criarNo() {
      if (this.form.uid === '') {
        EventBus.$emit(Topics.NOTIFICATIONS, {
          type: Types.WARNING,
          message: 'Selecione um id para o Link',
        })
        return
      }

      if (this.links[this.form.uid] != null) {
        EventBus.$emit(Topics.NOTIFICATIONS, {
          type: Types.WARNING,
          message: 'Id já existe',
        })
        return
      }

      if (this.from == null) {
        EventBus.$emit(Topics.NOTIFICATIONS, {
          type: Types.WARNING,
          message: 'Selecione um nó de origem',
        })
        return
      }

      if (this.to == null) {
        EventBus.$emit(Topics.NOTIFICATIONS, {
          type: Types.WARNING,
          message: 'Selecione um nó de destino',
        })
        return
      }

      if (this.form.diameter == null) {
        EventBus.$emit(Topics.NOTIFICATIONS, {
          type: Types.WARNING,
          message: 'Selecione um diâmetro',
        })
        return
      }

      if (this.form.roughness == null) {
        EventBus.$emit(Topics.NOTIFICATIONS, {
          type: Types.WARNING,
          message: 'Selecione uma rugosidade',
        })
        return
      }

      if (this.form.roughness < 0) {
        EventBus.$emit(Topics.NOTIFICATIONS, {
          type: Types.WARNING,
          message: 'Rugosidade deve ser maior que 0',
        })
        return
      }

      // eslint-disable-next-line no-unreachable
      const response = await http.post(
        `epanet/simulacao/${this.simulacaoId}/link`,
        {
          uid: this.form.uid,
          tipo: 1,
          from: this.from.idJuncao,
          to: this.to.idJuncao,
          length: this.form.length,
        }
      )

      if (+response === 1) {
        const changeResponse = await http.post(
          'epanet/simulacao/change',
          {
            tipo: 'LINE',
            simulacaoId: this.simulacaoId,
            uid: this.form.uid,
            dados: {
              roughness: this.form.roughness,
              diameter: this.form.diameter,
            },
          },
          false
        )

        if (!changeResponse) {
          EventBus.$emit(Topics.NOTIFICATIONS, {
            type: Types.WARNING,
            message: 'Erro ao criar link',
          })
        }

        this.$emit('save')
      }
    },
  },
}
</script>
